import React, { useState } from "react";
import "../Styles/style.css";

export default function ContactUs() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");

  return (
    <>
      <div className="infoMainConatiner py-5">
        <div className="container">
          <h4 className="termsMainHeading">Contact Us</h4>

          <div className="infoMainBody p-3">
            <div className="row m-5">
              <h5 className="color-blue">Your Details</h5>
              <div className="col-7 shadow-lg p-3 mb-5 bg-white rounded contactus_form">
                <form className="row px-3">
                  <div className="col-md-12 login_inputStyle mb-3">
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-user"></i>
                      </span>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        placeholder="Full Name"
                        aria-describedby="basic-addon1"
                        required
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 login_inputStyle mb-3">
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-envelope"></i>
                      </span>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="name@email.com"
                        aria-describedby="basic-addon1"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 login_inputStyle mb-3">
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-mobile"></i>
                      </span>
                      <input
                        type="number"
                        id="phone"
                        className="form-control"
                        placeholder="03xxxxxxxxx"
                        aria-describedby="basic-addon1"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 login_inputStyle mb-3">
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-message"></i>
                      </span>
                      <input
                        type="text"
                        id="message"
                        className="form-control"
                        placeholder="Message Here.."
                        aria-describedby="basic-addon1"
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <button
                      type="submit"
                      className="btn mt-3 fw-primary model_loginBTn w-100"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
              <div className="col"></div>
              <div className="col-4 shadow-lg p-3 mb-5 bg-white rounded contactus_info">
                <h4 className="">Feel free to call to say Hello!</h4>
                <br />
                <h5>Address</h5>
                <p className="">
                  Plot A-5 FL 3/4, KDA Scheme, Nehar-e-Khayyam Road, Block 5,
                  Clifton, Karachi
                </p>
                <br />
                <h5>Contact Information</h5>
                <p className="">
                  Phone: +92 213 5308703,
                  <br />
                  WhatsApp / Call: +92 300 111(FAME) / +92 300 1113263 , +92 326
                  2226222
                  <br />
                  Email: info@famewheels.com
                </p>
                <br />
                <h5>Office Timings</h5>
                <p className="">
                  Monday-Friday: 09:00am-07:00pm
                  <br />
                  Saturday-Sunday: 10:00am-06:00pm
                </p>
                <br />
                <p>
                  Find anything about <b>Automobiles</b> only on Famewheels.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
